import axios from "axios";

// console.log(`API KEY IS: ${process.env.REACT_APP_API_KEY}`)
// console.log(`API KEY TYPE IS: ${typeof(process.env.REACT_APP_API_KEY)}`)

export default axios.create({
  baseURL: "http://mfa150.jeniusmark.com/api/",
  httpsAgent: false,
  headers: {
    "Content-type": "application/json",
    "x-api-key": process.env.REACT_APP_API_KEY
  }
});
